export default __webpack_public_path__ + "static/media/password-done.acefd2bb.png";